import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import Header from '../components/Header';

const { FiFileText, FiExternalLink } = FiIcons;

const documents = [
  {
    title: 'WALL | WELL basic Info',
    url: 'https://flipbooklets.com/pdfflipbooklets/wall-well-basic-info',
    type: 'Katalog',
    image: 'https://media-manager-c.questera.ai/greta-media/6f193b2d92211423257b0e3c0dceb84ada06e24e969d96db08b6a1796096f07796f46a52af0758ac75a61f230dd98906/images/aW1hZ2UvanBlZw==/0413eb0817de347ade6754608b0b987e.jpeg'
  },
  {
    title: 'WALL | WELL WOOD TEXTURES',
    url: 'https://flipbooklets.com/pdfflipbooklets/wall-well-wood-textures',
    type: 'Katalog',
    image: 'https://media-manager-c.questera.ai/greta-media/6f193b2d92211423257b0e3c0dceb84ada06e24e969d96db08b6a1796096f07796f46a52af0758ac75a61f230dd98906/images/aW1hZ2UvcG5n/d0373d8a5383b3bd90f5aa77e21024f4.png'
  },
  {
    title: 'WALL | WELL ACOUSTIC',
    url: 'https://flipbooklets.com/pdfflipbooklets/wall-well-acoustic',
    type: 'Katalog',
    image: 'https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1784719781425-blob'
  },
  {
    title: 'WALL | WELL CATALOG 01',
    url: 'https://flipbooklets.com/pdfflipbooklets/wall-well-catalog',
    type: 'Katalog',
    image: 'https://media-manager-c.questera.ai/greta-media/6f193b2d92211423257b0e3c0dceb84ada06e24e969d96db08b6a1796096f07796f46a52af0758ac75a61f230dd98906/images/aW1hZ2UvanBlZw==/1a360e8fd932b96cccff050a5a986cd3.jpeg'
  },
  {
    title: 'WALL | WELL CERTIFICATE',
    url: 'https://flipbooklets.com/pdfflipbooklets/wall-well-certificate',
    type: 'Certifikát',
    image: 'https://media-manager-c.questera.ai/greta-media/6f193b2d92211423257b0e3c0dceb84ada06e24e969d96db08b6a1796096f07796f46a52af0758ac75a61f230dd98906/images/aW1hZ2UvanBlZw==/0aa25e4b5363d5565b051807160d426e.jpeg'
  },
  {
    title: 'WALL | WELL SOFT STONE',
    url: 'https://flipbooklets.com/pdfflipbooklets/wall-well-soft-stone',
    type: 'Katalog',
    image: 'https://media-manager-c.questera.ai/greta-media/6f193b2d92211423257b0e3c0dceb84ada06e24e969d96db08b6a1796096f07796f46a52af0758ac75a61f230dd98906/images/aW1hZ2UvanBlZw==/88ba7312b480d8513a45fd4111b9d277.jpeg'
  },
  {
    title: 'WALL | WELL FLOORING',
    url: 'https://flipbooklets.com/pdfflipbooklets/wall-well-flooring',
    type: 'Katalog',
    image: 'https://media-manager-c.questera.ai/greta-media/6f193b2d92211423257b0e3c0dceb84ada06e24e969d96db08b6a1796096f07796f46a52af0758ac75a61f230dd98906/images/aW1hZ2UvanBlZw==/18b3846d2cb4dfac1a6f0f98c5926dcd.jpeg'
  },
  {
    title: 'WALL | WELL ANTI COLLISION',
    url: 'https://flipbooklets.com/pdfflipbooklets/wall-well-anti-collision',
    type: 'Technický list',
    image: 'https://media-manager-c.questera.ai/greta-media/6f193b2d92211423257b0e3c0dceb84ada06e24e969d96db08b6a1796096f07796f46a52af0758ac75a61f230dd98906/images/aW1hZ2UvanBlZw==/70c3de35f7800f143b5f3fe64932d188.jpeg'
  },
  {
    title: 'WALL | WELL CATALOG 02',
    url: 'https://flipbooklets.com/pdfflipbooklets/wall-well-catalog2',
    type: 'Katalog',
    image: 'https://media-manager-c.questera.ai/greta-media/6f193b2d92211423257b0e3c0dceb84ada06e24e969d96db08b6a1796096f07796f46a52af0758ac75a61f230dd98906/images/aW1hZ2UvanBlZw==/d3a502a38a5fefabfa90a03414f9a23b.jpeg'
  },
  {
    title: 'WALL | WELL Zakončení hran',
    url: 'https://flipbooklets.com/pdfflipbooklets/wall-well-zakon-en-hran',
    type: 'Manuál',
    image: 'https://media-manager-c.questera.ai/greta-media/6f193b2d92211423257b0e3c0dceb84ada06e24e969d96db08b6a1796096f07796f46a52af0758ac75a61f230dd98906/images/aW1hZ2UvanBlZw==/490149d70a397eee84be0ab1f34b8cb2.jpeg'
  },
  {
    title: 'WALL | WELL Architektura a Design',
    url: 'https://flipbooklets.com/pdfflipbooklets/wall-well-architektura-a-design',
    type: 'Inspirace',
    image: 'https://media-manager-c.questera.ai/greta-media/6f193b2d92211423257b0e3c0dceb84ada06e24e969d96db08b6a1796096f07796f46a52af0758ac75a61f230dd98906/images/aW1hZ2UvanBlZw==/ba4d5e22e33c55a9bcd6264e662e7233.jpeg'
  },
  {
    title: 'WALL | WELL Picture Album',
    url: 'https://flipbooklets.com/pdfflipbooklets/wall-well-picture-album',
    type: 'Inspirace',
    image: 'https://media-manager-c.questera.ai/greta-media/6f193b2d92211423257b0e3c0dceb84ada06e24e969d96db08b6a1796096f07796f46a52af0758ac75a61f230dd98906/images/aW1hZ2UvanBlZw==/7441e961c0ae01cca688c9244296e29e.jpeg'
  }
];

const Downloads = () => {
  return (
    <motion.div
      className="min-h-screen bg-arch-light dark:bg-dark-bg text-arch-dark dark:text-gray-200 transition-colors duration-300"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.6 }}
    >
      <Header />
      <div className="pt-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
          <header className="mb-16 border-b border-arch-border dark:border-dark-border pb-10">
            <h1 className="text-4xl font-bold tracking-tight mb-4 text-arch-dark dark:text-white">
              Dokumenty ke stažení
            </h1>
            <p className="text-accent-teal font-mono text-sm">
              Katalogy, certifikáty, manuály a inspirativní materiály prohlížejte online nebo stahujte v PDF.
            </p>
          </header>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {documents.map((doc, idx) => (
              <motion.a
                key={doc.title}
                href={doc.url}
                target="_blank"
                rel="noopener noreferrer"
                className={`relative group border border-arch-border dark:border-dark-border p-8 hover:border-brand-500 dark:hover:border-brand-500 transition-all duration-300 flex flex-col h-full shadow-sm hover:shadow-xl overflow-hidden ${doc.image ? '' : 'bg-white dark:bg-dark-surface'}`}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: idx * 0.05 }}
              >
                {doc.image && (
                  <>
                    <div
                      className="absolute inset-0 bg-cover bg-center transition-transform duration-700 group-hover:scale-105"
                      style={{ backgroundImage: `url(${doc.image})` }}
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-arch-dark/95 via-arch-dark/40 to-arch-dark/70 transition-opacity duration-300 z-0" />
                  </>
                )}

                <div className="relative z-10 flex flex-col h-full">
                  <div className="flex items-start justify-between mb-8">
                    <div className={`w-12 h-12 flex items-center justify-center flex-shrink-0 group-hover:bg-brand-500 group-hover:border-brand-500 transition-colors duration-300 ${doc.image ? 'bg-white/10 backdrop-blur-sm border border-white/20' : 'bg-arch-light dark:bg-[#1A1D24] border border-arch-border dark:border-dark-border'}`}>
                      <SafeIcon
                        icon={FiFileText}
                        className={`w-5 h-5 transition-colors ${doc.image ? 'text-white' : 'text-arch-gray dark:text-gray-400 group-hover:text-white'}`}
                      />
                    </div>
                    <div className={`p-2 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300 ${doc.image ? 'bg-white/10 backdrop-blur-sm' : 'bg-arch-light dark:bg-[#1A1D24]'}`}>
                      <SafeIcon
                        icon={FiExternalLink}
                        className={`w-4 h-4 transition-colors ${doc.image ? 'text-white' : 'text-brand-500'}`}
                      />
                    </div>
                  </div>

                  <h3 className={`text-lg font-bold mb-2 transition-colors pr-4 ${doc.image ? 'text-white group-hover:text-brand-400' : 'text-arch-dark dark:text-white group-hover:text-brand-500'}`}>
                    {doc.title}
                  </h3>

                  <div className="mt-auto pt-6">
                    <span className={`inline-block px-3 py-1 text-[10px] font-bold uppercase tracking-widest transition-colors rounded-sm ${doc.image ? 'bg-black/30 backdrop-blur-md border border-white/20 text-brand-400 group-hover:border-brand-400' : 'bg-arch-light dark:bg-[#1A1D24] border border-arch-border dark:border-dark-border text-accent-teal group-hover:border-accent-teal'}`}>
                      {doc.type}
                    </span>
                  </div>
                </div>
              </motion.a>
            ))}
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default Downloads;